import { render, staticRenderFns } from "./bearish_flag.vue?vue&type=template&id=1be5ad5a"
import script from "./bearish_flag.vue?vue&type=script&lang=js"
export * from "./bearish_flag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports